module.exports = __webpack_public_path__ + "static/media/happy_bee.8688a1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bee/happy_bee.png
// module id = 158
// module chunks = 0